import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { Downy, Kournikova, mintGreen, white, MelrosePurple, lightBlueGrey, deepCoveDark, black } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { breakpoints, device } from "../../../../../../app/js/utils/responsive_utilities";
import { styledFont } from '../../../../common/mixins/mixin';
import { assetPath } from '../../../../../../app/js/utils/web-helper';
import OfferBannerImg from "~images/sem/offer_banner.png";

import { bounceAnimation } from "../../../../common/functions/animations";

export const ContainerWrapper = styled.div`
    width:100%;
    height:100%;
    background-color: ${deepCoveDark};
    padding-top: 3.7rem;
    position: relative;
    ${styledFont("Graphie")};

    @media (min-width: ${breakpoints.md}px){
        padding-top: 0;
        flex-direction: row;
    }
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 144rem;
  margin: 0 auto;

  @media (min-width: ${breakpoints.md}px){
    flex-direction: row;
  }
`

export const LeftContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    @media (min-width: ${breakpoints.md}px){
      width: 45%;
      padding: 6rem 0 0 8rem;
    }

    @media ${device.Tablet}{
      width: 55%;
    }

    @media ${device.Desktop}{
      padding: 6.5rem 0 0 13.4rem
    }
`

export const RightContainer = styled.div`
    @media (min-width: ${breakpoints.md}px){
      position: relative;
      width: 50%;
    }
`

export const GradeIcon = styled.div`
  width: 5.2rem;
  height: 5.2rem;
  position: absolute;
  bottom: 0;

  > img{
      width: 100%;
      height: 100%;
  }

  @media (min-width: ${breakpoints.md}px){
    width: 9.5rem;
    height: 9.8rem;
    bottom: -3.5rem;
    left: -6%;
  }

  @media ${device.Desktop}{
    width: 14rem;
    height: 14.7rem;
    bottom: -6.5rem;
  }
`

export const KidSection = styled.div`
    width: 84.3rem;
    height: 69.2rem;
    position: absolute;
    z-index: 1;
    bottom: -8rem;
  
    >img{
        width: 100%;
        height: 100%;
        position: relative;
    }

    @media ${device.Tablet}{
      width: 66.2rem;
      height: 60.4rem;
      left: -5rem;
    }
`

export const BannerSection = styled.div`
    display: flex;
    visibility: ${props => props.showBanner ? "visible" : "hidden"};
    margin: auto;
    @media (min-width: ${breakpoints.md}px){
        margin: 0 0 0 -8rem;
    }
`

export const LeftStarContainer = styled.div`
    width: 5rem;
    display: flex;
    justify-content: flex-end;

    @media (min-width: ${breakpoints.md}px){
        width: 8rem;
    }
`

export const RightStarContainer = styled.div`
    width: 5rem;
    display: flex;
    justify-content: flex-start;

    @media (min-width: ${breakpoints.md}px){
        width: 8rem;
    }
`

export const OfferBanner = styled.div`
    position: relative;
    margin: auto;
    @media (min-width: ${breakpoints.md}px){
      margin: auto 0;
    }
`

export const OfferDuration = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -1.4rem;
    background: ${Kournikova};
    border-radius: 0.7rem 0.7rem 0 0;
    padding: 0 0.5rem;
    text-align: center;
`

export const OfferDiscount = styled.div`
    display: inline-block;
    text-shadow: 0rem 0.351244rem 0rem rgb(0 0 0 / 25%);
    transform: matrix(1, -0.07, 0.07, 1, 0, 0);
    ${styledFont("Quicksand", 4, 4.5, 7)};
    padding: 0 0.5rem;

    @media ${device.Tablet}{
      ${styledFont("Quicksand", 3.6, 4, 7)};
    }

    @media ${device.Desktop}{
      ${styledFont("Quicksand", 4.5, 5, 7)};
    }
`

export const OfferStripe = styled.div`
    padding: 0.5rem 2rem;
    text-align: center;
    margin: auto;
    display: flex;
    position: relative;
    background: url(${assetPath(OfferBannerImg)}) top left/100% 100% no-repeat;
    color: ${white};
    ${styledFont("Graphie", 1.5, 1.9, 6)};
    text-align: center;
   

    @media ${device.Tablet}{
      ${styledFont("Graphie", 1.4, 1.7, 6)};
    }

    @media ${device.Desktop}{
      ${styledFont("Graphie", 1.8, 2.2, 6)};
      margin: unset;
    }
`

export const OfferStripeText = styled.p`
    display: flex;
    justify-content: center;
    align-items: center;
    margin:0;
    @media ${device.Tablet}{
      top: -0.5rem;
    }
`

export const CourseOffering = styled.div`
    color: ${mintGreen};
    ${styledFont("Graphie", 1.6, 1.9, 7)};
    margin-top: 2rem;
    text-align: center;

    @media (min-width: ${breakpoints.md}px){
      text-align: left;
      ${styledFont("Graphie", 2, 2.4, 7)};
    }
    @media ${device.Tablet}{
      ${styledFont("Graphie", 1.6, 1.9, 7)};
    }
`

export const HeadingText = styled(Heading1)`
    ${styledFont("Graphie", 3.2, 3.6, 7)};
    width: 70%;
    margin: 1rem auto;
    @media (min-width: ${breakpoints.md}px){
        margin: 0.4rem auto 1.4rem 0;
        text-align: left;
        width: 90%;
        ${styledFont("Graphie", 4.4, 5.2, 7)};
    }

    @media ${device.Tablet}{
      ${styledFont("Graphie", 3.2, 3.6, 7)};
    }    
`
export const SubHeadingText = styled(SubHeading)`
  width: 80%;
  color: ${black};
  margin: auto;
  /* padding-top: 0.5rem; */
  ${styledFont("Graphie", 1.6, 2, 6)}

  @media ${device.Desktop}{
    ${styledFont("Graphie", 2, 2.4, 6)}
  }
`

export const ListContainer = styled.div`
    color: ${white};
    margin: 2.6rem auto 0 auto;

    @media (min-width: ${breakpoints.md}px){
      width: 100%;
      text-align: left;
    }

    @media ${device.Desktop}{
      margin: 0rem auto;
    }

`

export const ListItem = styled.div`
    margin-bottom: 0.8rem;
    ${styledFont("Graphie", 1.4, 2, 6)};

    &::before{
        content: "";
        display: inline-block;
        background: ${Downy};
        width: 0.7rem;
        height:0.7rem;
        margin-right: 0.8rem;
        border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
        transform: rotate(270deg);
    }

    @media ${device.Tablet}{
      ${styledFont("Graphie", 1.4, 2, 6)};
    }

    @media ${device.Desktop}{
      margin-bottom: 1rem;
      ${styledFont("Graphie", 1.6, 2.4, 6)};
    }
`

export const VideoSection = styled.div`
    display: flex;
    justify-content: center;
    margin: 2.6rem 0 4.2rem 0;
    cursor: pointer;
    @media (min-width: ${breakpoints.md}px){
        justify-content: left;
        margin: 3.2rem 0 2.2rem 0;
    }

    @media ${device.Desktop}{
      margin: 1rem 0 3.2rem 0;
    }
`

export const VideoText = styled.div`
    text-align: center;
    text-decoration-line: underline;
    ${styledFont("Graphie", 1.4, 2.4, 6)};
    text-align: center;
    text-decoration-line: underline;
    color: ${MelrosePurple};
    margin-right: 0.5rem;

    @media ${device.Desktop}{
      ${styledFont("Graphie", 1.6, 3.2, 6)};
    }
`

export const VideoPlayBtnContainer = styled.div`
    border-radius: 50%;
    width: 2.1rem;
    height: 2.1rem;
    position:relative;
    display:flex;
    align-items: center;
    justify-content: center;
    margin: auto 0;
`;

export const VideoPlayBtn = styled.div`
    width: 2.1rem;
    height: 2.1rem;

    >img{
      width: 100%;
      height: 100%;
    }
`;

export const App = styled.div`
    display: flex;
    justify-content: center;
    margin: 3rem 0 4rem 0;

    @media (min-width: ${breakpoints.md}px){
        justify-content: left;
    }

    @media ${device.Desktop}{
      margin: 2.9rem 0 0.5rem 0;
    }
`

export const AppText = styled.div`
    color: ${lightBlueGrey};
    ${styledFont("Graphie", 1.3, 1.6, 6)};
`

export const AppStoreIcons = styled.div`
    display: flex;
    img{
        width: 1.3rem;
        height: 1.6rem;
        margin-left: 0.5rem;
    }
`

export const IconsContainer = styled.div`
    display:flex;
`

export const ElaIcon = styled.div`
    width: 4.6rem;
    height: 4.6rem;
    position: absolute;
    bottom: -1.2rem;
    left: 4rem;
    z-index: 3;
    top: 0;
    img{
        width: 100%;
        height: 100%;
        animation: ${bounceAnimation(0.5)} 2s ease infinite;
        animation-delay : ${props => props.delay}
    }

    @media (min-width: ${breakpoints.md}px){
      width: 4.3rem;
      height: 4.3rem;
      left: unset;
      right: 8%;
      /* z-index: 1; */
    }

    @media ${device.Desktop}{
      width: 6.4rem;
      height: 6.4rem;
      right: 18.5%;
    }
`

export const MathIcon = styled.div`
    position: absolute;
    width: 5.2rem;
    height: 5.2rem;
    bottom: -1rem;
    left: 0rem;
    z-index: 3;
    top: 0;

    img{
        width: 100%;
        height: 100%;
        animation: ${bounceAnimation(-0.5)} 2s ease infinite;
        animation-delay : ${props => props.delay}
    }

    @media (min-width: ${breakpoints.md}px){
      width: 5.9rem;
      height: 5.9rem;
      left: unset;
      right: 12%;
      /* z-index: 1; */
    }

    @media ${device.Desktop}{
      width: 9rem;
      height: 9rem;
      right: 22%;
    }
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  @media (min-width: ${breakpoints.md}px){
    justify-content: left;
  }
`
export const KidSafe = styled.div`
  width: 7.4rem;
  height: 2.7rem;
  margin: auto;
  > img{
    width: 100%;
    height: 100%;
  }

  @media (min-width: ${breakpoints.md}px) {
    > img{
      width: 9.5rem;
      height: 3.4rem;
    }
  }
`
export const BottomSection = styled.div`
  background-color: ${white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2;
  position: relative;
`

export const BottomWave = styled.div`
  z-index: 2;
  position: relative;
  >img{
    width: 100%;
    height: 100%;
    display: block;
  }
`
export const BottomHeadingText = styled(Heading1)`
  text-align: center;
  color: ${black};
  ${styledFont("Graphie", 3.2, 3.6, 7)};
  margin: 0.8rem 0;
  @media (min-width: ${breakpoints.md}px){     
    ${styledFont("Graphie", 4.4, 5.2, 7)};
  }

  @media ${device.Tablet}{
    ${styledFont("Graphie", 3.2, 3.6, 7)};
  }    
`
